import Service from "../../Classes/Service";
import { serviceModalSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = {
    open: false,
    serviceToAdd: new Service(),
    addOrEdit: ""
}

export default function serviceModalSlice(state = initialState, action) {
    switch (action.type) {
        case serviceModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case serviceModalSliceDispatch.setServiceToAdd: {
            return {
                ...state,
                serviceToAdd: action.payload
            }
        }
        default:
            return state
    }
}
